import { IChild } from 'main/gql/child'
import { dateInputIsValid, formatDateAsInput } from 'main/util/date'
import { IChildParams, IChildValidation } from './types'

export function initialParams(child: IChild | null): IChildParams {
  return {
    birthday: (child && child.birthday && formatDateAsInput(child.birthday)) || '',
    desiredEnrollmentDate:
      (child && child.desiredEnrollmentDate && formatDateAsInput(child.desiredEnrollmentDate)) ||
      '',
    firstName: (child && child.firstName) || '',
    gender: child && child.gender,
    id: (child && child.id) || null,
    lastName: (child && child.lastName) || '',
  }
}

export function validate(params: IChildParams) {
  const hints: IChildValidation = {}

  if (!params.firstName.trim()) {
    hints.firstName = 'Please enter a first name'
  }

  if (!params.lastName.trim()) {
    hints.lastName = 'Please enter a last name'
  }

  if (!params.gender) {
    hints.gender = 'Please select a gender'
  }

  if (!params.birthday) {
    hints.birthday = 'Please enter a date of birth'
  } else if (!dateInputIsValid(params.birthday)) {
    hints.birthday = 'Please enter a valid date (mm/dd/yyyy)'
  }

  if (!params.desiredEnrollmentDate) {
    hints.desiredEnrollmentDate = 'Please enter a desired start date'
  } else if (!dateInputIsValid(params.desiredEnrollmentDate)) {
    hints.desiredEnrollmentDate = 'Please enter a valid date (mm/dd/yyyy)'
  }

  return Object.keys(hints).length ? hints : null
}

export function validateChild(child: IChild) {
  const params = initialParams(child)

  return validate(params)
}
